import { FelaCSS } from '@bridebook/ui';

interface IStyles {
  wrapper: FelaCSS;
}

const styles: IStyles = {
  wrapper: {
    display: 'inline-flex',
    cursor: 'pointer',
  },
};

export default styles;
